import { QrCode } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { CheckList, Chip, PhoneFrame } from '../compass/shared';

// Section 5 — fast frontline reporting. Mobile-first, two genuine mobile
// journey screenshots; no claims of anonymous/offline/public reporting.
export const ForeseeFrontline = ({ sp }) => (
  <section aria-labelledby="foresee-frontline-heading" data-testid="foresee-frontline" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <SectionHeader
            align="left"
            eyebrow="Frontline Reporting"
            title="Make it easier for people to report what they see"
            description={sp.frontlineCopy}
            testid="foresee-frontline-header"
          />
          <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Supported report types</h3>
          <div className="mt-3 flex flex-wrap gap-2" data-testid="foresee-report-types">
            {(sp.reportTypes || []).map((t) => <Chip key={t}>{t}</Chip>)}
          </div>
          <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-slate-500">What a report can include</h3>
          <div className="mt-4">
            <CheckList items={sp.reportInputs || []} testid="foresee-report-inputs" />
          </div>
          <p className="mt-6 flex items-start gap-2.5 rounded-lg border border-indigo-100 bg-indigo-50/60 p-4 text-sm font-medium leading-relaxed text-navy-800">
            <QrCode className="mt-0.5 h-4 w-4 shrink-0 text-indigo-600" aria-hidden="true" />
            Where configured, site-specific QR codes can provide a direct route to the relevant reporting experience.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="flex items-start justify-center gap-5 sm:gap-8">
            <PhoneFrame shot={sp.shots.reportPicker} className="w-40 sm:w-52" />
            <PhoneFrame shot={sp.shots.reportForm} className="mt-10 w-40 sm:w-52" />
          </div>
          <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-widest text-slate-400">
            Product visuals show illustrative demonstration data
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
